import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39b83b96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-12" }
const _hoisted_2 = { class: "card-header flex-column flex-nowrap justify-content-around pb-4 pt-6 px-3 mx-6" }
const _hoisted_3 = { class: "card-title m-0 py-3" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "px-9 pb-6 pt-4" }
const _hoisted_6 = { class: "row py-6 gy-lg-7 gy-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Order Type", -1))
const _hoisted_8 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Customer Name", -1))
const _hoisted_10 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Store Name", -1))
const _hoisted_12 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Car Description", -1))
const _hoisted_14 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Pickup Location", -1))
const _hoisted_16 = { class: "col-lg-7 d-flex justify-content-between" }
const _hoisted_17 = { class: "fw-bolder fs-5 text-dark" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Show Map")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Date Order", -1))
const _hoisted_20 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Date Service Start", -1))
const _hoisted_22 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Date Service End", -1))
const _hoisted_24 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Date Service Count", -1))
const _hoisted_26 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Price (TH)", -1))
const _hoisted_28 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Pay Method", -1))
const _hoisted_30 = { class: "col-lg-7 fw-bolder fs-5 text-dark" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Pay Status", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bolder text-muted fs-5" }, "Customer Note", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-lg-7 fw-bolder fs-5 text-dark" }, /*#__PURE__*/_toDisplayString('-'), -1))
const _hoisted_34 = { class: "card-header flex-column flex-nowrap justify-content-around pb-4 pt-6 px-3 mx-6" }
const _hoisted_35 = { class: "card-title m-0 py-3" }
const _hoisted_36 = { class: "fw-bolder m-0 fs-2" }
const _hoisted_37 = { class: "px-9 pb-6 pt-4" }
const _hoisted_38 = { class: "row py-6" }
const _hoisted_39 = { class: "col-lg-3 col-xl-2 fw-bold text-muted text-lg-start text-center" }
const _hoisted_40 = { class: "symbol symbol-100px symbol-lg-150px symbol-fixed position-relative" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "symbol symbol-150px" }
const _hoisted_43 = ["src"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-img overlay-layer" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-white" }, " image_search ")
], -1))
const _hoisted_45 = { class: "col-lg-9 col-xl-10 fw-bold fs-6 text-dark" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "pb-4 pt-7 pt-lg-0 fs-2" }
const _hoisted_48 = { class: "material-icons me-3 opacity-50" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "pb-4 pt-7 pt-lg-0 fs-2" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-lg-3 text-muted fs-4" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Type : ")
const _hoisted_54 = { class: "fw-bolder text-dark" }
const _hoisted_55 = { class: "col-lg-9 text-muted fs-4" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Tags : ")
const _hoisted_57 = { class: "fw-bolder text-dark" }
const _hoisted_58 = { class: "col-lg-3 text-muted fs-4" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Brand : ")
const _hoisted_60 = { class: "fw-bolder text-dark" }
const _hoisted_61 = { class: "col-lg-4 text-muted fs-4" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Model : ")
const _hoisted_63 = { class: "fw-bolder text-dark" }
const _hoisted_64 = { class: "col-lg-5 text-muted fs-4" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Sub Model : ")
const _hoisted_66 = { class: "fw-bolder text-dark" }
const _hoisted_67 = { class: "col-lg-3 text-muted fs-4" }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Model Year : ")
const _hoisted_69 = { class: "fw-bolder text-dark" }
const _hoisted_70 = { class: "col-lg-4 text-muted fs-4" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Transmission : ")
const _hoisted_72 = { class: "fw-bolder text-dark" }
const _hoisted_73 = { class: "col-lg-5 text-muted fs-4" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Fuel Type : ")
const _hoisted_75 = { class: "fw-bolder text-dark" }
const _hoisted_76 = { class: "col-lg-12 text-muted fs-4" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Option : ")
const _hoisted_78 = { class: "fw-bolder text-dark" }
const _hoisted_79 = {
  class: "modal fade",
  tabindex: "-1",
  id: "modal"
}
const _hoisted_80 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_81 = { class: "modal-content bg-transparent shadow-none" }
const _hoisted_82 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, " Order ID: " + _toDisplayString(_ctx.order.id ? _ctx.order.id.slice(16).toUpperCase() : null), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.convertCamelToTitle(_ctx.order.package?.id)), 1),
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.customer.name || '-'), 1),
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.partner.organization?.name), 1),
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.carDescription), 1),
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.node.name), 1),
            _createVNode(_component_router_link, {
              to: `/location/node-province/${_ctx.node.id}`,
              class: "fw-bolder fs-5 text-primary me-lg-8"
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _hoisted_19,
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.moment(_ctx.order.createdAt).format('DD/MM/YYYY')), 1),
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.moment(_ctx.order.startDate).format('DD/MM/YYYY')), 1),
          _hoisted_23,
          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.moment(_ctx.order.endDate).format('DD/MM/YYYY')), 1),
          _hoisted_25,
          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.order.days + ' ' + _ctx.day), 1),
          _hoisted_27,
          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.order.amountPrice), 1),
          _hoisted_29,
          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.order.payment?.method || '-'), 1),
          _hoisted_31,
          _createElementVNode("span", {
            class: _normalizeClass([
            _ctx.order.payment?.gbpReferenceNo ? 'text-success' : 'text-danger'
          , "col-lg-7 fw-bolder fs-5"])
          }, _toDisplayString(_ctx.order.payment?.gbpReferenceNo ? 'Paid' : 'Unpaid'), 3),
          _hoisted_32,
          _hoisted_33
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.details, (detail, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "card mb-12"
      }, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("h3", _hoisted_36, _toDisplayString(detail.name), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", {
                  class: "overlay cursor-pointer",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#modal",
                  onClick: ($event: any) => (_ctx.changeImage(detail.image))
                }, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("img", {
                      src: detail.image,
                      alt: "partner image"
                    }, null, 8, _hoisted_43),
                    _hoisted_44
                  ])
                ], 8, _hoisted_41)
              ])
            ]),
            _createElementVNode("span", _hoisted_45, [
              (detail.descriptions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("h3", _hoisted_47, _toDisplayString(detail.labelName), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.descriptions, (description, j) => {
                      return (_openBlock(), _createElementBlock("p", {
                        class: "d-flex fw-bolder fs-4",
                        key: j
                      }, [
                        _createElementVNode("span", _hoisted_48, _toDisplayString(description.icon), 1),
                        _createTextVNode(" " + _toDisplayString(description.label), 1)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    _createElementVNode("h3", _hoisted_50, _toDisplayString(detail.labelName), 1),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("p", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.car.type?.name), 1)
                      ]),
                      _createElementVNode("p", _hoisted_55, [
                        _hoisted_56,
                        _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.car.tags.join(', ') || '-'), 1)
                      ]),
                      _createElementVNode("p", _hoisted_58, [
                        _hoisted_59,
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.car.brand?.name), 1)
                      ]),
                      _createElementVNode("p", _hoisted_61, [
                        _hoisted_62,
                        _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.car.model?.name), 1)
                      ]),
                      _createElementVNode("p", _hoisted_64, [
                        _hoisted_65,
                        _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.car.series?.name), 1)
                      ]),
                      _createElementVNode("p", _hoisted_67, [
                        _hoisted_68,
                        _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.car.year), 1)
                      ]),
                      _createElementVNode("p", _hoisted_70, [
                        _hoisted_71,
                        _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.car.transmission), 1)
                      ]),
                      _createElementVNode("p", _hoisted_73, [
                        _hoisted_74,
                        _createElementVNode("span", _hoisted_75, _toDisplayString(_ctx.car.feuls.map((fuel) => fuel.name).join(', ') || '-'), 1)
                      ]),
                      _createElementVNode("p", _hoisted_76, [
                        _hoisted_77,
                        _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.car.carOptions.join(', ') || '-'), 1)
                      ])
                    ])
                  ]))
            ])
          ])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_79, [
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("img", {
            class: "figure-img img-fluid rounded m-0",
            src: _ctx.currentImage,
            alt: "modal image"
          }, null, 8, _hoisted_82)
        ])
      ])
    ])
  ], 64))
}